<div class="flex flex-col flex-auto min-w-0 bg-card dark:bg-transparent" >
    <div class="relative flex items-center justify-center h-auto">
        <div class="max-w-12xl w-full pt-4 bg-white-100 dark:bg-transparent dark:text-white  h-full">
            <div class="relative flex my-2 mobile-responsive" >
                <input
                class="appearance-none border-2 w-full border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white mobile-responsive"
                type="text"
                id="filter-text-box"
                placeholder="Filter..."
                [(ngModel)]="filterText"
                id="filterText"
                (keyup.enter)="search()"
                />
            
                        <button id="filterButton" type="button" class="bg-blue-500 mx-1 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" (click)="search()" aria-label="search" tooltip="{{'Search' | translate}}">
                            <i class="fa fa-search"></i>
                        </button>
                        <!-- <button  type="button" class="bg-transparent hover:bg-blue text-blue-dark mx-1 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" (click)="clearFilter()">
                            
                        </button> -->
                        <button type="button" (click)="clear()" class="btn btn-outline-secondary" aria-label="clear" tooltip="{{'Clear' | translate}}">
                            <i class="fa fa-times"></i>
                        </button>
                
                
                    <!-- <button id="filterButton1" class="bg-transparent hover:bg-secondary text-blue-dark font-semibold hover:text-secondary py-2 px-4 border border-gray-300 hover:border-secondary rounded">
                        
                    </button> -->
                
            </div>
        </div>

        
    </div>
</div>
